import type { JSX } from 'react'
import type { IButtonProps } from '../Button'

import { IconNames } from 'atoms/Icon'
import { COLOR } from 'vars/color'
import { Button } from '../Button'
import {
  ButtonBordersWidth,
  ButtonColors,
  ButtonCorners,
  ButtonFluid,
  ButtonFonts,
  ButtonIconSizes,
  IconPositions,
} from '../Button.h'

export interface IInlineCloseButtonProps extends IButtonProps {}

export const InlineCloseButton = ({
  icon = IconNames.close,
  iconSize = ButtonIconSizes.medium,
  corners = ButtonCorners.CORNERS_10,
  colorDefault = ButtonColors.COLOR_PRIMARY,
  colorDisabled = ButtonColors.COLOR_DISABLED,
  backgroundColorDefault = COLOR.TRANSPARENT,
  backgroundColorDisabled = COLOR.TRANSPARENT,
  borderWidth = ButtonBordersWidth.BORDER_0,
  font = ButtonFonts.Button1,
  fluid = ButtonFluid.None,
  ...rest
}: IInlineCloseButtonProps): JSX.Element => {
  return (
    <Button
      iconPosition={IconPositions.Center}
      icon={icon}
      iconSize={iconSize}
      corners={corners}
      colorDefault={colorDefault}
      colorDisabled={colorDisabled}
      backgroundColorDefault={backgroundColorDefault}
      backgroundColorDisabled={backgroundColorDisabled}
      borderWidth={borderWidth}
      font={font}
      fluid={fluid}
      {...rest}
    />
  )
}
